import useLayerListeners from './useLayerListeners';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import { Ref, WatchStopHandle } from 'vue';
import { LAYER_CONFIG_OMIT_PROP } from '../constants';

export default function useCircleLayer(mapInstance: LooseObject, layerInfo: Ref<MapLayer<CircleLayerConfig>>) {
  if (!layerInfo.value || !layerInfo.value.config) return;

  const { id: layerId } = layerInfo.value;

  let circleStyle; let geometries;
  let unwatchList: WatchStopHandle[] | null = [];

  const circleLayer = new TMap.MultiCircle({
    id: layerId,
    map: mapInstance,
  });

  unwatchList.push(watchEffect(() => {
    const styleConfig = omit(layerInfo.value.config, LAYER_CONFIG_OMIT_PROP);
    const styleOption = mapValues(styleConfig, val => toRaw(unref(val)));
    circleStyle = new TMap.CircleStyle(styleOption);
    if (circleLayer) circleLayer.setStyles({ circleStyle });
  }));

  unwatchList.push(watchEffect(() => {
    if (!Array.isArray(layerInfo.value.config.data)) return;
    try {
      geometries = layerInfo.value.config.data.map((geometry: CircleGeometry, index: number) => {
        const { id, center, radius } = geometry;
        return {
          id: id ? id : `${index}`,
          center: new TMap.LatLng(center.lat, center.lng),
          radius,
          styleId: 'circleStyle',
        };
      });
      if (circleLayer) circleLayer.setGeometries(geometries);
    } catch (error) {
      if (circleLayer) circleLayer.setGeometries([]);
    }
  }));

  // 用户传入的事件回调在这里处理
  unwatchList.push(watchEffect(() => {
    useLayerListeners(circleLayer, [
      { eventName: 'click', callbackList: layerInfo.value.config.onClick },
      { eventName: 'hover', callbackList: layerInfo.value.config.onHover },
    ]);
  }));

  circleLayer.unmount = (): void => {
    circleLayer?.destroy();
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };

  return circleLayer;
}
